import { render, staticRenderFns } from "./BiStatisticsCard.vue?vue&type=template&id=78407d80&"
import script from "./BiStatisticsCard.vue?vue&type=script&lang=js&"
export * from "./BiStatisticsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports